module.exports = __webpack_public_path__ + "static/media/home.849b7bcb.mp4";